/**
 *      ev08_solemp.js
 *          Script de ev02_16pf.vue
 *          Valida los valres ingresados, calcula los resultados y genera la grafica en un PDF.
 */
/* ======================================================================================================== */
import moment from 'moment'
import ingreso from './ingreso.vue'

import Vue from 'vue';
import jsPDF from 'jspdf'
Vue.use(jsPDF)

import { store } from './../store/store'

import 'materialize-css/dist/css/materialize.min.css'
import M from 'materialize-css'

export default {
     name: 'solempleo',
     components: {
          'moment': moment,
          'input-date': ingreso,
     },
     template: `#formanpf`,
     data() {
          var vm = this;
          return {
               estados: [
                    { text: 'Soltero', value: 'Soltero' },
                    { text: 'Casado', value: 'Casado' },
                    { text: 'Viudo', value: 'Viudo' },
                    { text: 'Unido', value: 'Unido' },
               ],
               nacionalidades: [
                    { text: 'Guatemalteco', value: 'Guatemalteco' },
                    { text: 'Salvadoreño', value: 'Salvadoreño' },
                    { text: 'Hondureño', value: 'Hondureño' },
                    { text: 'Nicaraguense', value: 'Nicaraguense' },
                    { text: 'Costarricense', value: 'Costarricense' },
                    { text: 'Mejicano', value: 'Mejicano' },
                    { text: 'Estadounidense', value: 'Estadounidense' },
               ],
               ejemplo: {},
               eval_solemp: {}, res: {},
               modo: "",
               eval_fecha: new Date(),
               eval_naci: new Date(),
               instrucciones: "",
               inicioeval: false, finalizoeval: false, grabado: false,
               pregSinContestar: 0, ejeSinResponder: 0,
               conteo1: null, conteo2: null, seconds: 0, minutos: 0,

               //? .....................................................................................................................................................................................................................
               activott1:"active", activott2: '!active', activott3: "!active", activott4:"!active", activott5: '!active', 
               activott6: "!active", activott7:"!active", activott8: '!active', activott9: "!active", 
               vertt1: true, vertt2: false, vertt3: false, vertt4: false, vertt5: false, 
               vertt6: false, vertt7: false, vertt8: false, vertt9: false, 

          } // return
     }, // data()
     mounted() {

          /** Definiciones para el uso de los slides y tooltips */
          var elems = document.querySelectorAll('.collapsible');
          var instances = M.Collapsible.init(elems, {});

          var elems = document.querySelectorAll('.tooltipped');
          var instances = M.Tooltip.init(elems, {});

          var elem = document.querySelectorAll('.tabs');
          var instances = M.Tabs.init(elem, {});

          var elems = document.querySelectorAll('select');
          var instances = M.FormSelect.init(elems, {});

          this.conteo1 = new Date().getTime();

          // var vm = this;
          // var x = setInterval(
          //      function(){

          //           vm.conteo2 = new Date().getTime();
          //           vm.diferen = vm.conteo2 - vm.conteo1;
          //           vm.seconds = Math.floor((vm.diferen % (1000 * 60)) / 1000);
          //           console.log("inicia: ", vm.conteo1, ", finaliza: ",vm.conteo2,", dif ? ",vm.seconds);

          //           if (vm.seconds >= 59){

          //                vm.minutos = vm.minutos + 1;
          //                console.log("minutos ? ", vm.minutos);
          //           }
          //      },1000);

          /** obtiene localmente el caso definido en el almacén (store) */
          this.cargaEvaluacion();
     },
     methods: {
          solicitud(doc){

               var lblanco = '';
               var lfaplico = this.eval_solemp.fecha;
               var lempezo = this.eval_solemp.empezo;
               var ltermino = this.eval_solemp.termino;
               var lcodigo = this.eval_solemp.codigo;
               var lncompleto = this.eval_solemp.pg001;
               var llugnac = this.eval_solemp.pg002;
               var lfecnac = this.eval_solemp.pg003;
               var ledad = this.eval_solemp.pg004;
               var ldpi = this.eval_solemp.pg005;
               var lextendido = this.eval_solemp.pg006;
               var ligss = this.eval_solemp.pg007;
               var lnit = this.eval_solemp.pg008;
               var lpg007 = this.eval_solemp.pg007;
               var lpg008 = this.eval_solemp.pg008;
               var lpg009 = this.eval_solemp.pg009;
               var lpg010 = this.eval_solemp.pg010;
               var lpg011 = this.eval_solemp.pg011;
               var lpg012 = this.eval_solemp.pg012;
               var lpg013 = this.eval_solemp.pg013;
               var lpg014 = this.eval_solemp.pg014;
               var lpg015 = this.eval_solemp.pg015;
               var lpg016 = this.eval_solemp.pg016;
               var lpg017 = this.eval_solemp.pg017;
               var lpg018 = this.eval_solemp.pg018;
               var lpg019 = this.eval_solemp.pg019;
               var lpg020 = this.eval_solemp.pg020;
               var lpg021 = this.eval_solemp.pg021;
               var lpg023 = this.eval_solemp.pg023;
               var lpg025 = this.eval_solemp.pg025;
               var lpg022 = this.eval_solemp.pg022.toString() + '; ' + lpg023;
               var lpg024 = this.eval_solemp.pg024.toString() + '; ' + lpg025;

               var lpg026 = this.eval_solemp.pg026;
               var lpg027 = this.eval_solemp.pg027;
               var lpg028 = this.eval_solemp.pg028;
               var lpg029 = this.eval_solemp.pg029;
               var lpg030 = this.eval_solemp.pg030;
               var lpg031 = this.eval_solemp.pg031;
               var lpg032 = this.eval_solemp.pg032;
               var lpg033 = this.eval_solemp.pg033;
               var lpg034 = this.eval_solemp.pg034;
               var lpg035 = this.eval_solemp.pg035;
               var lpg036 = this.eval_solemp.pg036;
               var lpg037 = this.eval_solemp.pg037;
               var lpg038 = this.eval_solemp.pg038;
               var lpg039 = this.eval_solemp.pg039;
               var lpg040 = this.eval_solemp.pg040;
               var lpg041 = this.eval_solemp.pg041;
               var lpg042 = this.eval_solemp.pg042;
               var lpg043 = this.eval_solemp.pg043;
               var lpg044 = this.eval_solemp.pg044;
               var lpg045 = this.eval_solemp.pg045;
               var lpg046 = this.eval_solemp.pg046;
               var lpg047 = this.eval_solemp.pg047;
               var lpg048 = this.eval_solemp.pg048;
               var lpg049 = this.eval_solemp.pg049;
               var lpg050 = this.eval_solemp.pg050;
               var lpg051 = this.eval_solemp.pg051;
               var lpg052 = this.eval_solemp.pg052;
               var lpg053 = this.eval_solemp.pg053;
               var lpg054 = this.eval_solemp.pg054;
               var lpg055 = this.eval_solemp.pg055;
               var lpg056 = this.eval_solemp.pg056;
               var lpg057 = this.eval_solemp.pg057;
               var lpg058 = this.eval_solemp.pg058;
               var lpg059 = this.eval_solemp.pg059;
               var lpg060 = this.eval_solemp.pg060;
               var lpg061 = this.eval_solemp.pg061;
               var lpg062 = this.eval_solemp.pg062;
               var lpg063 = this.eval_solemp.pg063;
               var lpg064 = this.eval_solemp.pg064;
               var lpg065 = this.eval_solemp.pg065;
               var lpg066 = this.eval_solemp.pg066;
               var lpg067 = this.eval_solemp.pg067;
               var lpg068 = this.eval_solemp.pg068;
               var lpg069 = this.eval_solemp.pg069;
               var lpg070 = this.eval_solemp.pg070;
               var lpg071 = this.eval_solemp.pg071;
               var lpg072 = this.eval_solemp.pg072;
               var lpg073 = this.eval_solemp.pg073;
               var lpg074 = this.eval_solemp.pg074;
               var lpg075 = this.eval_solemp.pg075;
               var lpg076 = this.eval_solemp.pg076;
               var lpg077 = this.eval_solemp.pg077;
               var lpg078 = this.eval_solemp.pg078;
               var lpg079 = this.eval_solemp.pg079;
               var lpg080 = this.eval_solemp.pg080;
               var lpg081 = this.eval_solemp.pg081;
               var lpg082 = this.eval_solemp.pg082;
               var lpg083 = this.eval_solemp.pg083;
               var lpg084 = this.eval_solemp.pg084;
               var lpg085 = this.eval_solemp.pg085;
               var lpg086 = this.eval_solemp.pg086;
               var lpg087 = this.eval_solemp.pg087;
               var lpg088 = this.eval_solemp.pg088;
               var lpg089 = this.eval_solemp.pg089;
               var lpg090 = this.eval_solemp.pg090;
               var lpg091 = this.eval_solemp.pg091;
               var lpg092 = this.eval_solemp.pg092;
               var lpg093 = this.eval_solemp.pg093;
               var lpg094 = this.eval_solemp.pg094;
               var lpg095 = this.eval_solemp.pg095;
               var lpg096 = this.eval_solemp.pg096;
               var lpg097 = this.eval_solemp.pg097;
               var lpg098 = this.eval_solemp.pg098;
               var lpg099 = this.eval_solemp.pg099;
               var lpg100 = this.eval_solemp.pg100;
               var lpg101 = this.eval_solemp.pg101;
               var lpg102 = this.eval_solemp.pg102;
               var lpg103 = this.eval_solemp.pg103;
               var lpg104 = this.eval_solemp.pg104;
               var lpg105 = this.eval_solemp.pg105;
               var lpg106 = this.eval_solemp.pg106;
               var lpg107 = this.eval_solemp.pg107;
               var lpg108 = this.eval_solemp.pg108;
               var lpg109 = this.eval_solemp.pg109;
               var lpg110 = this.eval_solemp.pg110;
               var lpg111 = this.eval_solemp.pg111;
               var lpg112 = this.eval_solemp.pg112;
               var lpg113 = this.eval_solemp.pg113;
               var lpg114 = this.eval_solemp.pg114;
               var lpg115 = this.eval_solemp.pg115;
               var lpg116 = this.eval_solemp.pg116;
               var lpg117 = this.eval_solemp.pg117;
               var lpg118 = this.eval_solemp.pg118;
               var lpg119 = this.eval_solemp.pg119;
               var lpg120 = this.eval_solemp.pg120;
               var lpg121 = this.eval_solemp.pg121;
               var lpg122 = this.eval_solemp.pg122;
               var lpg123 = this.eval_solemp.pg123;
               var lpg124 = this.eval_solemp.pg124;
               var lpg125 = this.eval_solemp.pg125;
               var lpg126 = this.eval_solemp.pg126;
               var lpg127 = this.eval_solemp.pg127;
               var lpg128 = this.eval_solemp.pg128;
               var lpg129 = this.eval_solemp.pg129;
               var lpg130 = this.eval_solemp.pg130;
               var lpg131 = this.eval_solemp.pg131;
               var lpg132 = this.eval_solemp.pg132;
               var lpg133 = this.eval_solemp.pg133;
               var lpg134 = this.eval_solemp.pg134;
               var lpg135 = this.eval_solemp.pg135;
               var lpg136 = this.eval_solemp.pg136;
               var lpg137 = this.eval_solemp.pg137;
               var lpg138 = this.eval_solemp.pg138;
               var lpg139 = this.eval_solemp.pg139;
               var lpg140 = this.eval_solemp.pg140;
               var lpg141 = this.eval_solemp.pg141;
               var lpg142 = this.eval_solemp.pg142;
               var lpg143 = this.eval_solemp.pg143;
               var lpg144 = this.eval_solemp.pg144;
               var lpg145 = this.eval_solemp.pg145;
               var lpg146 = this.eval_solemp.pg146;
               var lpg147 = this.eval_solemp.pg147;
               var lpg148 = this.eval_solemp.pg148;
               var lpg149 = this.eval_solemp.pg149;
               var lpg150 = this.eval_solemp.pg150;
               var lpg151 = this.eval_solemp.pg151;
               var lpg152 = this.eval_solemp.pg152;
               var lpg153 = this.eval_solemp.pg153;
               var lpg154 = this.eval_solemp.pg154;
               var lpg155 = this.eval_solemp.pg155;
               var lpg156 = this.eval_solemp.pg156;
               var lpg157 = this.eval_solemp.pg157;
               var lpg158 = this.eval_solemp.pg158;
               var lpg159 = this.eval_solemp.pg159;
               var lpg160 = this.eval_solemp.pg160;
               var lpg161 = this.eval_solemp.pg161;
               var lpg162 = this.eval_solemp.pg162;
               var lpg163 = this.eval_solemp.pg163;
               var lpg164 = this.eval_solemp.pg164;
               var lpg165 = this.eval_solemp.pg165;
               var lpg166 = this.eval_solemp.pg166;
               var lpg167 = this.eval_solemp.pg167;
               var lpg168 = this.eval_solemp.pg168;
               var lpg169 = this.eval_solemp.pg169;
               var lpg170 = this.eval_solemp.pg170;
               var lpg171 = this.eval_solemp.pg171;
               var lpg172 = this.eval_solemp.pg172;
               var lpg173 = this.eval_solemp.pg173;
               var lpg174 = this.eval_solemp.pg174;
               var lpg175 = this.eval_solemp.pg175;
               var lpg176 = this.eval_solemp.pg176;
               var lpg177 = this.eval_solemp.pg177;
               var lpg178 = this.eval_solemp.pg178;
               var lpg179 = this.eval_solemp.pg179;
               var lpg180 = this.eval_solemp.pg180;
               var lpg181 = this.eval_solemp.pg181;
               var lpg182 = this.eval_solemp.pg182;
               var lpg183 = this.eval_solemp.pg183;
               var lpg184 = this.eval_solemp.pg184;
               var lpg185 = this.eval_solemp.pg185;
               var lpg186 = this.eval_solemp.pg186;
               var lpg187 = this.eval_solemp.pg187;
               var lpg188 = this.eval_solemp.pg188;
               var lpg189 = this.eval_solemp.pg189;
               var lpg190 = this.eval_solemp.pg190;
               var lpg191 = this.eval_solemp.pg191;
               var lpg192 = this.eval_solemp.pg192;
               var lpg193 = this.eval_solemp.pg193;
               var lpg194 = this.eval_solemp.pg194;
               var lpg195 = this.eval_solemp.pg195;
               var lpg196 = this.eval_solemp.pg196;
               var lpg197 = this.eval_solemp.pg197;
               var lpg198 = this.eval_solemp.pg198;
               var lpg199 = this.eval_solemp.pg199;
               var lpg200 = this.eval_solemp.pg200;
               var lpg201 = this.eval_solemp.pg201;
               var lpg202 = this.eval_solemp.pg202;
               var lpg203 = this.eval_solemp.pg203;
               var lpg204 = this.eval_solemp.pg204;
               var lpg205 = this.eval_solemp.pg205;
               var lpg206 = this.eval_solemp.pg206;
               var lpg207 = this.eval_solemp.pg207;

               doc.setLineWidth(0.7);
               doc.line(13, 50, 195, 50); // horizontal line (init_col, init_row, , )

               doc.setFontSize(9);
               doc.setFontType("bold");
               doc.text(13, 57, 'I) INFORMACION PERSONAL');
               doc.setLineWidth(0.5);
               doc.rect(12, 59, 185, 45);              /*  rect(init_col, init_row, end_col, end_row) */
               doc.setFontType("bolditalic");
               doc.text(15, 70, 'LUGAR Y FECHA DE NACIMIENTO:');
               doc.text(15, 76, 'EDAD:');
               doc.text(35, 76, 'DPI:');
               doc.text(100, 76, 'EXTENDIDA EN:');
               let llugfecnac = llugnac + '; ' + lfecnac;
               console.log("llugnac ?",llugnac, "; lfecnad ? ", lfecnac,"; llugfecnad ? ", llugfecnac)
               doc.setFontType("normal");
               doc.text(72, 70, llugfecnac);
               doc.text(27, 76, ledad.toString());
               doc.text(45, 76, ldpi);
               doc.text(127, 76, lextendido);
               console.log("pasé !!!!")
               doc.setFontType("bolditalic");
               doc.text(15, 82, 'AFILIACION AL IGSS:');
               doc.text(95, 82, 'NIT:');
               doc.text(130, 82, 'ESTADO CIVIL:');
               doc.setFontType("normal");
               doc.text(50, 82, lpg007);
               doc.text(103, 82, lpg008);
               doc.text(160, 82, lpg009);

               doc.setFontType("bolditalic");
               doc.text(15, 88, 'NACIONALIDAD:');          /* pg010 */
               doc.text(100, 88, 'PROFESION U OFICIO:');
               doc.setFontType("normal");
               doc.text(45, 88, lpg010);
               doc.text(150, 88, lpg011);

               doc.setFontType("bolditalic");
               doc.text(15, 94, 'DIRECCION ACTUAL:');
               doc.text(140, 94, 'E-MAIL:');
               doc.setFontType("normal");
               var msg = 'E-MAIL';
               var pos1 = 140 + msg.length + 7;
               doc.text(52, 94, lpg012);
               doc.text(pos1, 94, lpg013);

               doc.setFontType("bolditalic");
               let msg1 = 'TELEFONO DOMICILIO:';
               let msg2 = 'TELEFONO CELULAR:';
               pos1 = 15 + msg1.length + 20;
               let pos2 = 100 + msg2.length + 20;
               doc.text(15, 100, msg1);
               doc.text(100, 100, msg2);
               doc.setFontType("normal");
               doc.text(pos1, 100, lpg014);
               doc.text(pos2, 100, lpg015);

               doc.rect(12, 111, 185, 120);              /*  rect(init_col, init_row, end_col, end_row) */
               doc.setFontType("bold");
               doc.text(13, 110, 'II) DATOS FAMILIARES');
               doc.setFontType("bolditalic");
               doc.text(15, 116, 'NOMBRE DEL PADRE:');
               doc.text(110, 116, 'TELEFONO:');
               doc.setFontType("normal");
               doc.text(55, 116, lpg016);
               doc.text(135, 116, lpg017);
               doc.setFontType("bolditalic");
               doc.text(15, 121, 'LUGAR DE TRABAJO:');
               doc.setFontType("normal");
               doc.text(55, 121, lpg018);

               doc.setFontType("bolditalic");
               doc.text(15, 127, 'NOMBRE DE LA MADRE:');
               doc.text(110, 127, 'TELEFONO:');
               doc.setFontType("normal");
               doc.text(55, 127, lpg019);
               doc.text(135, 127, lpg020);

               doc.setFontType("bolditalic");
               doc.text(15, 133, 'LUGAR DE TRABAJO:');
               doc.setFontType("normal");
               doc.text(55, 133, lpg021);

               doc.setFontType("bolditalic");
               doc.text(15, 139, 'No. DE HERMANOS Y PROFESIONES:');
               doc.text(15, 145, 'No. DE CARGAS FAMILIARES Y QUIENES:');
               doc.setFontType("normal");
               doc.text(85, 139, lpg022);
               doc.text(85, 145, lpg024);

               doc.setFontType("bolditalic");
               doc.text(75, 151, '------ DATOS DEL CONYUGUE ------');
               doc.text(15, 157, 'NOMBRE COMPLETO:');
               doc.text(110, 157, 'OCUPACION:');
               doc.setFontType("normal");
               doc.text(55, 157, lpg026);
               doc.text(135, 157, lpg027);
               doc.setFontType("bolditalic");
               doc.text(15, 163, 'LUGAR DE TRABAJO:');
               doc.setFontType("normal");
               doc.text(55, 163, lpg028);
               doc.setFontType("bolditalic");
               doc.text(15, 169, 'DIRECCION:');
               doc.text(110, 169, 'TELEFONO:');
               doc.setFontType("normal");
               doc.text(55, 169, lpg029);
               doc.text(135, 169, lpg030);
               doc.setFontType("bolditalic");
               doc.text(15, 174, 'CARGO QUE OCUPA:');
               doc.setFontType("normal");
               doc.text(55, 174, lpg031);
               doc.setFontType("bolditalic");

               doc.text(75, 180, '------ DATOS DE LOS HIJOS ------');
               doc.text(15, 186, '1) NOMBRE:');
               doc.text(110, 186, 'EDAD:');
               doc.setFontType("normal");
               doc.text(55, 186, lpg032);
               doc.text(135, 186, lpg033);
               doc.setFontType("bolditalic");
               doc.text(18, 192, 'ESCOLARIDAD:');
               doc.text(110, 192, 'INSTITUCION:');
               doc.setFontType("normal");
               doc.text(55, 192, lpg034);
               doc.text(135, 192, lpg035);
               doc.setFontType("bolditalic");

               doc.text(15, 198, '2) NOMBRE:');
               doc.text(110, 198, 'EDAD:');
               doc.setFontType("normal");
               doc.text(55, 198, lpg036);
               doc.text(135, 198, lpg037);
               doc.setFontType("bolditalic");
               doc.text(18, 204, 'ESCOLARIDAD:');
               doc.text(110, 204, 'INSTITUCION:');
               doc.setFontType("normal");
               doc.text(55, 204, lpg038);
               doc.text(135, 204, lpg039);
               doc.setFontType("bolditalic");

               doc.text(15, 210, '3) NOMBRE:');
               doc.text(110, 210, 'EDAD:');
               doc.setFontType("normal");
               doc.text(55, 210, lpg040);
               doc.text(135, 210, lpg041);
               doc.setFontType("bolditalic");
               doc.text(18, 216, 'ESCOLARIDAD:');
               doc.text(110, 216, 'INSTITUCION:');
               doc.setFontType("normal");
               doc.text(55, 216, lpg042);
               doc.text(135, 216, lpg043);
               doc.setFontType("bolditalic");
               doc.text(15, 222, '4) NOMBRE:');
               doc.text(110, 222, 'EDAD:');
               doc.setFontType("normal");
               doc.text(55, 222, lpg044);
               doc.text(135, 222, lpg045);
               doc.setFontType("bolditalic");
               doc.text(18, 228, 'ESCOLARIDAD:');
               doc.text(110, 228, 'INSTITUCION:');
               doc.setFontType("normal");
               doc.text(55, 228, lpg046);
               doc.text(135, 228, lpg047);

               doc.rect(12, 239, 185, 30);              /*  rect(init_col, init_row, end_col, end_row) */
               doc.setFontType("bold");
               doc.text(13, 238, 'III) INFORMACION SOCIOECONOMICA');
               doc.setFontType("bolditalic");
               doc.text(15, 244, 'VIVE EN CASA PROPIA ?');
               doc.text(85, 244, 'ALQUILA ?');
               doc.text(130, 244, 'DE SUS PADRES ?');
               doc.setFontType("normal");
               doc.text(55, 244, lpg048);
               doc.text(105, 244, lpg049);
               doc.text(160, 244, lpg050);
               doc.setFontType("bolditalic");
               doc.text(15, 250, 'TIENE VEHICULO PROPIO ?');
               doc.text(130, 250, 'MARCA Y AÑO');
               doc.setFontType("normal");
               doc.text(60, 250, lpg051);
               let lpg5253 = lpg052 + '; ' + lpg053;
               doc.text(160, 250, lpg5253);
               doc.setFontType("bolditalic");
               doc.text(15, 256, 'RECIBE OTROS INGRESOS QUE NO SEAN DE SU SUELDO ?');
               doc.text(130, 256, 'MONTO');
               doc.setFontType("normal");
               doc.text(110, 256, lpg054);
               doc.text(160, 256, lpg055);
               doc.setFontType("bolditalic");
               doc.text(15, 262, 'DE DONDE PROCEDE ESTE INGRESO');
               doc.setFontType("normal");
               doc.text(80, 262, lpg056);
               doc.setFontType("bolditalic");

               doc.setFontType("normal");

               /* ========================================================================================== */
               /* PAGINA 2 */
               doc.addPage();
               doc.text(15, 10, 'Segunda Página');
               doc.text(135, 10, lncompleto);
               doc.setLineWidth(0.7);
               doc.line(13, 14, 200, 14); // horizontal line (init_col, init_row, , )
               doc.setFontType("bold");
               doc.text(13, 20, 'IV) FORMACION ACADEMICA');
               doc.rect(12, 22, 190, 125);    /*  RECTANGULO (init_col, init_row, end_col, end_row) */
               doc.setFontType("bolditalic");
               doc.text(13, 26, '- POSTGRADO ');
               doc.text(13, 32, '1) INSTITUCION:');
               doc.text(98, 32, 'GRADO OBTENIDO Y TITULO:');
               doc.text(13, 38, 'FECHA:');
               doc.setFontType("normal");
               doc.text(39, 32, lpg057);
               doc.text(145, 32, lpg058);
               doc.text(30, 38, lpg059);
               doc.setFontType("bolditalic");
               doc.text(13, 44, '2) INSTITUCION:');
               doc.text(98, 44, 'GRADO OBTENIDO Y TITULO:');
               doc.text(13, 50, 'FECHA:');
               doc.setFontType("normal");
               doc.text(39, 44, lpg060);
               doc.text(145, 44, lpg061);
               doc.text(30, 50, lpg062);
               doc.setFontType("bolditalic");

               doc.text(13, 56, '- UNIVERSITARIA');
               doc.text(13, 62, 'INSTITUCION:');
               doc.text(93, 62, 'GRADO OBTENIDO Y TITULO:');
               doc.text(13, 68, 'FECHA:');
               doc.setFontType("normal");
               doc.text(36, 62, lpg063);
               doc.text(141, 62, lpg064);
               doc.text(30, 68, lpg065);
               doc.setFontType("bolditalic");

               doc.text(13, 74, '- DIVERSIFICADA');
               doc.text(13, 80, 'INSTITUCION:');
               doc.text(93, 80, 'GRADO OBTENIDO Y TITULO:');
               doc.text(13, 86, 'FECHA:');
               doc.setFontType("normal");
               doc.text(39, 80, lpg066);
               doc.text(141, 80, lpg067);
               doc.text(30, 86, lpg068);
               doc.setFontType("bolditalic");

               doc.text(13, 92, '- OTROS CURSOS DE ACTUALIZACION RELACIONADOS CON SU PROFESION:');
               doc.setFontType("normal");
               doc.text(140, 92, lpg069);
               doc.setFontType("bolditalic");
               doc.text(13, 98, '- OTROS CONOCIMIENTOS O HABILIDADES QUE POSEE:');
               doc.setFontType("normal");
               doc.text(110, 98, lpg070);
               doc.setFontType("bolditalic");
               doc.text(13, 104, '- PREMIOS O MENCIONES HONORIFICAS OBTENIDAS:');
               doc.text(13, 116, '- ESTUDIA ACTUALMENTE ?');
               doc.text(65, 116, 'ESPECIFIQUE:');
               doc.text(13, 122, '  HORARIO:');
               doc.setFontType("normal");
               doc.text(13, 110, lpg071);
               doc.text(59, 116, lpg072);
               doc.text(90, 116, lpg073);
               doc.text(35, 122, lpg074);
               doc.setFontType("bolditalic");

               doc.text(75, 128, '------ IDIOMAS ADICIONALES ------');
               doc.text(13, 136, '1) IDIOMA:');
               doc.text(110, 136, 'LEE ');
               doc.text(130, 136, 'ESCRIBE');
               doc.text(155, 136, 'CONVERSA');
               doc.setFontType("normal");
               doc.text(35, 136, lpg075);
               doc.text(120, 136, lpg076);
               doc.text(148, 136, lpg077);
               doc.text(180, 136, lpg078);
               doc.setFontType("bolditalic");

               doc.text(13, 142, '2) IDIOMA:');
               doc.text(110, 142, 'LEE ');
               doc.text(130, 142, 'ESCRIBE');
               doc.text(155, 142, 'CONVERSA');
               doc.setFontType("normal");
               doc.text(35, 142, lpg079);
               doc.text(120, 142, lpg080);
               doc.text(148, 142, lpg081);
               doc.text(180, 142, lpg082);

               doc.setFontType("bold");
               doc.text(13, 150, 'V) EXPERIENCIA LABORAL (LOS TRES ULTIMOS EMPLEOS)');
               doc.rect(12, 152, 190, 130);              /*  rect(init_col, init_row, end_col, end_row) */
               doc.setFontType("bolditalic");
               doc.text(13, 156, '- EMPRESA 1 ');
               doc.text(13, 162, '  NOMBRE:');
               doc.text(125, 162, 'TELEFONO:');
               doc.text(13, 168, '  DIRECCION:');
               doc.text(13, 174, '  GIRO DEL NEGOCIO:');
               doc.text(13, 180, '  FECHA DE INGRESO:');
               doc.text(67, 180, 'FECHA DE EGRESO:');
               doc.text(118, 180, 'TRABAJA ACTUALMENTE EN ESTA EMPRESA ?');
               doc.text(13, 186, '  CARGO INICIAL:');
               doc.text(110, 186, 'CARGO ACTUAL:');
               doc.text(13, 192, '  SALARIO INICIAL:');
               doc.text(110, 192, 'SALARIO ACTUAL:');
               doc.text(13, 198, '  OTRAS PRESTACIONES DE LEY (ALMUERZOS, PARQUEO, MEMBRESIAS, ETC.)');
               doc.text(65, 206, '------ FUNCIONES PRINCIPALES DESEMPEÑADAS ------');
               doc.text(13, 212, '  1) ');
               doc.text(13, 218, '  2) ');
               doc.text(13, 224, '  3) ');
               doc.text(13, 230, '  4) ');
               doc.text(13, 236, '  5) ');
               doc.text(13, 242, '  6) ');
               doc.text(13, 248, '  NOMBRE DE SU JEFE INMEDIATO:');
               doc.text(13, 254, '  PUESTO DE SU JEFE INMEDIATO:');
               doc.text(13, 260, '  NUMERO DE PERSONAS A SU CARGO:');
               doc.text(13, 266, '  MOTIVO DE SU RETIRO:');
               doc.text(13, 272, '  PODEMOS PEDIR REFERENCIAS ?');
               doc.text(13, 278, '  PORQUE:');
               doc.setFontType("normal");
               doc.text(35, 162, lpg083);
               doc.text(150, 162, lpg084);
               doc.text(35, 168, lpg085);
               doc.text(50, 174, lpg086);
               doc.text(49, 180, lpg087);
               doc.text(100, 180, lpg088);
               doc.text(196, 180, lpg089);
               doc.text(45, 186, lpg090);
               doc.text(140, 186, lpg091);
               doc.text(45, 192, lpg092);
               doc.text(145, 192, lpg093);
               doc.text(15, 202, lpg094);
               doc.text(21, 212, lpg095);
               doc.text(21, 218, lpg096);
               doc.text(21, 224, lpg097);
               doc.text(21, 230, lpg098);
               doc.text(21, 236, lpg099);
               doc.text(21, 242, lpg100);
               doc.text(79, 248, lpg101);
               doc.text(79, 254, lpg102);
               doc.text(79, 260, lpg103);
               doc.text(79, 266, lpg104);
               doc.text(79, 272, lpg105);
               doc.text(79, 278, lpg106);

               /* ========================================================================================== */
               /* PAGINA 3 */
               doc.addPage();
               doc.text(15, 10, 'Tercera Página');
               doc.text(135, 10, lncompleto);
               doc.setLineWidth(0.7);
               doc.line(13, 14, 200, 14); // horizontal line (init_col, init_row, , )

               doc.rect(12, 20, 190, 265);    /*  RECTANGULO (init_col, init_row, end_col, end_row) */
               doc.setFontType("bolditalic");
               doc.text(13, 24, '- EMPRESA 2 ');
               doc.text(13, 30, '  NOMBRE:');
               doc.text(125, 30, 'TELEFONO:');
               doc.text(13, 36, ' DIRECCION:');
               doc.text(13, 42, '  GIRO DEL NEGOCIO:');
               doc.text(13, 48, '  FECHA DE INGRESO:');
               doc.text(67, 48, 'FECHA DE EGRESO:');
               doc.text(115, 48, 'TRABAJA ACTUALMENTE EN ESTA EMPRESA ?');
               doc.text(13, 54, '  CARGO INICIAL:');
               doc.text(110, 54, 'CARGO ACTUAL:');
               doc.text(13, 60, '  SALARIO INICIAL:');
               doc.text(110, 60, 'SALARIO ACTUAL:');
               doc.text(13, 65, '  OTRAS PRESTACIONES DE LEY (ALMUERZOS, PARQUEO, MEMBRESIAS, ETC.)');
               doc.text(65, 74, '------ FUNCIONES PRINCIPALES DESEMPEÑADAS ------');
               doc.text(13, 80, '  1) ');
               doc.text(13, 86, '  2) ');
               doc.text(13, 92, '  3) ');
               doc.text(13, 98, '  4) ');
               doc.text(13, 104, '  5) ');
               doc.text(13, 110, '  6) ');
               doc.text(13, 116, '  NOMBRE DE SU JEFE INMEDIATO:');
               doc.text(13, 122, '  PUESTO DE SU JEFE INMEDIATO:');
               doc.text(13, 128, '  NUMERO DE PERSONAS A SU CARGO:');
               doc.text(13, 134, '  MOTIVO DE SU RETIRO:');
               doc.text(13, 140, '  PODEMOS PEDIR REFERENCIAS ?');
               doc.text(13, 146, '  PORQUE:');
               doc.setFontType("normal");
               doc.text(35, 30, lpg107);
               doc.text(150, 30, lpg108);
               doc.text(35, 36, lpg109);
               doc.text(50, 42, lpg110);
               doc.text(49, 48, lpg111);
               doc.text(100, 48, lpg112);
               doc.text(196, 48, lpg113);
               doc.text(45, 54, lpg114);
               doc.text(140, 54, lpg115);
               doc.text(45, 60, lpg116);
               doc.text(145, 60, lpg117);
               doc.text(15, 70, lpg118);
               doc.text(21, 80, lpg119);
               doc.text(21, 86, lpg120);
               doc.text(21, 92, lpg121);
               doc.text(21, 98, lpg122);
               doc.text(21, 104, lpg123);
               doc.text(21, 110, lpg124);
               doc.text(79, 116, lpg125);
               doc.text(79, 122, lpg126);
               doc.text(79, 128, lpg127);
               doc.text(79, 134, lpg128);
               doc.text(79, 140, lpg129);
               doc.text(79, 146, lpg130);


               doc.line(13, 150, 200, 150); // horizontal line (init_col, init_row, , )
               doc.setFontType("bolditalic");
               doc.text(13, 156, '- EMPRESA 3 ');
               doc.text(13, 161, '  NOMBRE:');
               doc.text(125, 161, 'TELEFONO:');
               doc.text(13, 166, ' DIRECCION:');
               doc.text(13, 172, '  GIRO DEL NEGOCIO:');
               doc.text(13, 178, '  FECHA DE INGRESO:');
               doc.text(67, 178, 'FECHA DE EGRESO:');
               doc.text(115, 178, 'TRABAJA ACTUALMENTE EN ESTA EMPRESA ?');
               doc.text(13, 184, '  CARGO INICIAL:');
               doc.text(110, 184, 'CARGO ACTUAL:');
               doc.text(13, 191, '  SALARIO INICIAL:');
               doc.text(110, 191, 'SALARIO ACTUAL:');
               doc.text(13, 196, '  OTRAS PRESTACIONES DE LEY (ALMUERZOS, PARQUEO, MEMBRESIAS, ETC.)');
               doc.text(65, 206, '------ FUNCIONES PRINCIPALES DESEMPEÑADAS ------');
               doc.text(13, 212, '  1) ');
               doc.text(13, 218, '  2) ');
               doc.text(13, 224, '  3) ');
               doc.text(13, 230, '  4) ');
               doc.text(13, 236, '  5) ');
               doc.text(13, 242, '  6) ');
               doc.text(13, 248, '  NOMBRE DE SU JEFE INMEDIATO:');
               doc.text(13, 254, '  PUESTO DE SU JEFE INMEDIATO:');
               doc.text(13, 260, '  NUMERO DE PERSONAS A SU CARGO:');
               doc.text(13, 266, '  MOTIVO DE SU RETIRO:');
               doc.text(13, 272, '  PODEMOS PEDIR REFERENCIAS ?');
               doc.text(13, 278, '  PORQUE:');
               doc.setFontType("normal");
               doc.text(35, 161, lpg131);
               doc.text(150, 161, lpg132);
               doc.text(35, 166, lpg133);
               doc.text(50, 172, lpg134);
               doc.text(49, 178, lpg135);
               doc.text(100, 178, lpg136);
               doc.text(196, 178, lpg137);
               doc.text(45, 184, lpg138);
               doc.text(140, 184, lpg139);
               doc.text(45, 191, lpg140);
               doc.text(145, 191, lpg141);
               doc.text(15, 200, lpg142);
               doc.text(21, 212, lpg143);
               doc.text(21, 218, lpg144);
               doc.text(21, 224, lpg145);
               doc.text(21, 230, lpg146);
               doc.text(21, 236, lpg147);
               doc.text(21, 242, lpg148);
               doc.text(79, 248, lpg149);
               doc.text(79, 254, lpg150);
               doc.text(79, 260, lpg151);
               doc.text(79, 266, lpg152);
               doc.text(79, 272, lpg153);
               doc.text(79, 278, lpg154);

               /* ========================================================================================== */
               /* PAGINA 4 */
               doc.addPage();
               doc.text(15, 10, 'Cuarta Página');
               doc.text(135, 10, lncompleto);
               doc.setLineWidth(0.7);
               doc.line(13, 14, 200, 14); // horizontal line (init_col, init_row, , )
               doc.setFontType("bold");
               doc.text(13, 20, 'VI) FORMACION ACADEMICA');
               doc.rect(12, 22, 190, 260);    /*  RECTANGULO (init_col, init_row, end_col, end_row) */
               doc.setFontType("bolditalic");
               doc.text(13, 32, 'Organización, cultural, deportiva, religiosa, sindical u otras a las que pertenecido:');
               doc.text(13, 50, 'Escriba algún deporte o pasatiempo preferido:');
               doc.text(13, 68, '* Salud en General:');
               doc.text(13, 74, '  Ha padecido de alguna enfermedad en los últimos 3 años ?');
               doc.text(13, 80, '  ESPECIFIQUE:');
               doc.text(13, 86, '* Condiciones de Trabajo:');
               doc.text(13, 92, '  Puesto al que aplica ?');
               doc.text(13, 98, '  Expectativa salarial ');
               doc.text(13, 106, '  Tiene limitaciones de horario ?');
               doc.text(75, 106, '  ESPECIFIQUE:');
               doc.text(13, 112, '  ¿ A partir de qué fecha está disponible ?');
               doc.text(13, 118, '  Está dispuesto a viajar como parte de su trabajo ?');
               doc.text(13, 124, '  Posee pasaporte vigente ?');
               doc.text(70, 124, '  No. de Pasaporte ');
               doc.text(13, 130, '* Información complementaria:');
               doc.text(13, 136, '  Ha tenido problemas con la justicia ?');
               doc.text(85, 136, '  EXPLIQUE:');
               doc.text(13, 142, '  Hay deudas de alguna naturaleza ?');
               doc.text(85, 142, '  EXPLIQUE:');
               doc.text(13, 148, '  Tiene tatuajes ?');
               doc.setFontType("normal");
               doc.text(13, 36, '* ' + lpg155);
               doc.text(13, 42, '* ' + lpg156);
               doc.text(13, 54, lpg157);
               doc.text(110, 54, lpg158);
               doc.text(13, 60, lpg159);
               doc.text(110, 60, lpg160);
               doc.text(120, 74, lpg161);
               doc.text(55, 80, lpg162);
               doc.text(65, 92, lpg163);
               doc.text(65, 98, lpg164);
               doc.text(65, 106, lpg165);
               doc.text(102, 106, lpg166);
               doc.text(80, 112, lpg167);
               doc.text(95, 118, lpg168);
               doc.text(62, 124, lpg169);
               doc.text(99, 124, lpg170);
               doc.text(75, 136, lpg171);
               doc.text(135, 136, lpg172);
               doc.text(75, 142, lpg173);
               doc.text(135, 142, lpg174);
               doc.text(75, 148, lpg175);

               doc.line(13, 151, 200, 151); // horizontal line (init_col, init_row, , )
               doc.setFontType("bolditalic");
               doc.text(13, 160, 'VII) REFERENCIAS PERSONALES Y LABORALES');
               doc.text(13, 166, '* Referencias Personales:');
               doc.text(13, 172, '  a) NOMBRE:');
               doc.text(100, 172, '  TELEFONO:');
               doc.text(13, 178, '       E-MAIL:');
               doc.text(100, 178, '  OCUPACION:');
               doc.text(13, 184, '  b) NOMBRE:');
               doc.text(100, 184, '  TELEFONO:');
               doc.text(13, 190, '       E-MAIL:');
               doc.text(100, 190, '  OCUPACION:');
               doc.text(13, 196, '  c) NOMBRE:');
               doc.text(100, 196, '  TELEFONO:');
               doc.text(13, 202, '       E-MAIL:');
               doc.text(100, 202, '  OCUPACION:');
               doc.text(13, 208, '  d) NOMBRE:');
               doc.text(100, 208, '  TELEFONO:');
               doc.text(13, 214, '       E-MAIL:');
               doc.text(100, 214, '  OCUPACION:');
               doc.setFontType("normal");
               doc.text(35, 172, lpg176);
               doc.text(125, 172, lpg177);
               doc.text(35, 178, lpg178);
               doc.text(125, 178, lpg179);
               doc.text(35, 184, lpg180);
               doc.text(125, 184, lpg181);
               doc.text(35, 190, lpg182);
               doc.text(125, 190, lpg183);
               doc.text(35, 196, lpg184);
               doc.text(125, 196, lpg185);
               doc.text(35, 202, lpg186);
               doc.text(125, 202, lpg187);
               doc.text(35, 208, lpg188);
               doc.text(125, 208, lpg189);
               doc.text(35, 214, lpg190);
               doc.text(125, 214, lpg191);

               doc.setFontType("bolditalic");
               doc.text(13, 228, '* Referencias Labrales:');
               doc.text(13, 234, '  a) EMPRESA:');
               doc.text(100, 234, '  NOMBRE:');
               doc.text(13, 240, '       TEL Y E-MAIL:');
               doc.text(100, 240, '  OCUPACION:');
               doc.text(13, 246, '  b) EMPRESA:');
               doc.text(100, 246, '  NOMBRE:');
               doc.text(13, 252, '       TEL Y E-MAIL:');
               doc.text(100, 252, '  OCUPACION:');
               doc.text(13, 258, '  c) EMPRES:');
               doc.text(100, 258, '  NOMBRE:');
               doc.text(13, 264, '       TEL Y E-MAIL:');
               doc.text(100, 264, '  OCUPACION:');
               doc.text(13, 270, '  d) EMPRESA:');
               doc.text(100, 270, '  NOMBRE:');
               doc.text(13, 276, '       TEL Y E-MAIL:');
               doc.text(100, 276, '  OCUPACION:');
               doc.setFontType("normal");
               doc.text(37, 234, lpg192);
               doc.text(125, 234, lpg193);
               doc.text(43, 240, lpg194);
               doc.text(125, 240, lpg195);
               doc.text(37, 246, lpg196);
               doc.text(125, 246, lpg197);
               doc.text(43, 252, lpg198);
               doc.text(125, 252, lpg199);
               doc.text(37, 258, lpg200);
               doc.text(125, 258, lpg201);
               doc.text(43, 264, lpg202);
               doc.text(125, 264, lpg203);
               doc.text(37, 270, lpg204);
               doc.text(125, 270, lpg205);
               doc.text(43, 276, lpg206);
               doc.text(125, 276, lpg207);

          },
          crearPDF() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_solemp.nombre,
                    patron = / /g,
                    nuevoValor = "",
                    nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "solemp_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new jsPDF('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1);                    // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación de SOLICITUD DE EMPLEO para " + this.eval_solemp.nombre + " de " + this.eval_solemp.empresa);

               this.solicitud(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          addADayToMyDate() {
               if (this.eval_fecha) // as myDate can be null
                    // you have to set the this.myDate again, so vue can detect it changed
                    // this is not a caveat of this specific solution, but of any binding of dates
                    this.eval_solemp.empezo = new Date(this.eval_fecha.setDate(this.eval_fecha.getDate() + 1));
          },
          dateToYYYYMMDD(date) {
               console.log("***********************************************************************************");
               console.log("Estoy en dateToYYYYMMDD ");
               console.log("date ? ", date, "; typeof ", typeof (date));
               console.log("date.toISOString().split('T')[0] ? ", date.toISOString().split('T')[0]);
               console.log("date && date.toISOString().split('T')[0] ?", date && date.toISOString().split('T')[0]);

               console.log("Desmenuzando ...");
               var a = date.toISOString();
               var b = a.split("T");
               var c = b[0];
               var d = b[1];
               console.log("a) date.toISOString() ", date.toISOString());
               console.log("b) ", a.split("T"));
               console.log("c) b[0]", b[0], "; b[1] ", b[1]);
               console.log("***********************************************************************************");

               // may have timezone caveats https://stackoverflow.com/a/29774197/1850609
               return date && date.toISOString().split('T')[0]
          },
          cargaHora() {

               // Convierte la hora obtenida a hora local (utc)
               // this.eval_fecha = new Date();
               var d = new Date();
               var utcd = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(),
                    d.getMinutes(), d.getSeconds(), d.getMilliseconds());

               // obtain local UTC offset and convert to msec
               let localOffset = d.getTimezoneOffset() * 60000;
               var newdate = new Date(utcd + localOffset);
               var hours = newdate.getHours();
               var minutes = newdate.getMinutes();
               var seconds = newdate.getSeconds();
               var hora = hours + ":" + minutes + ":" + seconds;
               console.log("newdate ? ", newdate, " | ", hora);

               return hora;
          },
          cargaEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0,
               };

               this.eval_solemp = store.state.st_ev08;        // Crea el nodo para todos los campos.
               this.res_solemp = store.state.st_rs08;

               console.log("Cargando evaluación !");
               console.log(this.eval_solemp);
               this.eval_solemp.nombre = store.state.st_nusuario;    // Nombre del usuario que hará la evaluación
               this.eval_solemp.empresa = store.state.st_empresa;     // Nombre de la empresa a la cual pertenece el usuario
               this.eval_solemp.fecha   = this.eval_fecha;

               this.instrucciones = this.eval_solemp.nombre.toUpperCase() + " haga click aqui para leer las instrucciones para responder la evaluación de SOLICITUD DE EMPLEO."

               // this.eval_fecha = new Date();                 // Fecha del Día
          },
          empezarEvaluacion() {

               this.eval_solemp.empezo = this.cargaHora();
               this.inicioeval = true;
          },
          /** .................... VALIDACIONES  .................... */
          limpiarEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0,
               };

               this.eval_solemp = {
                    depto: "",
                    empresa: "", nombre: "",
                    fecha: "",
                    empezo: "", termino: "",
                    pg001: "", pg002: "", pg003: new Date(), pg004: 0, pg005: "", pg006: "", pg007: "", pg008: "", pg009: "", pg010: "",
                    pg011: "", pg012: "", pg013: "", pg014: "", pg015: "", pg016: "", pg017: "", pg018: "", pg019: "", pg020: "",
                    pg021: "", pg022: "", pg023: "", pg024: "", pg025: "", pg026: "", pg027: "", pg028: "", pg029: "", pg030: "",
                    pg031: "", pg032: "", pg033: "", pg034: "", pg035: "", pg036: "", pg037: "", pg038: "", pg039: "", pg040: "",
                    pg041: "", pg042: "", pg043: "", pg044: "", pg045: "", pg046: "", pg047: "", pg048: "", pg049: "", pg050: "",
                    pg051: "", pg052: "", pg053: "", pg054: "", pg055: "", pg056: "", pg057: "", pg058: "", pg059: "", pg060: "",
                    pg061: "", pg062: "", pg063: "", pg064: "", pg065: "", pg066: "", pg067: "", pg068: "", pg069: "", pg070: "",
                    pg071: "", pg072: "", pg073: "", pg074: "", pg075: "", pg076: "", pg077: "", pg078: "", pg079: "", pg080: "",
                    pg081: "", pg082: "", pg083: "", pg084: "", pg085: "", pg086: "", pg087: "", pg088: "", pg089: "", pg090: "",
                    pg091: "", pg092: "", pg093: "", pg094: "", pg095: "", pg096: "", pg097: "", pg098: "", pg099: "", pg100: "",
                    pg101: "", pg102: "", pg103: "", pg104: "", pg105: "", pg106: "", pg107: "", pg108: "", pg109: "", pg110: "",
                    pg111: "", pg112: "", pg113: "", pg114: "", pg115: "", pg116: "", pg117: "", pg118: "", pg119: "", pg120: "",
                    pg121: "", pg122: "", pg123: "", pg124: "", pg125: "", pg126: "", pg127: "", pg128: "", pg129: "", pg130: "",
                    pg131: "", pg132: "", pg133: "", pg134: "", pg135: "", pg136: "", pg137: "", pg138: "", pg139: "", pg140: "",
                    pg141: "", pg142: "", pg143: "", pg144: "", pg145: "", pg146: "", pg147: "", pg148: "", pg149: "", pg150: "",
                    pg151: "", pg152: "", pg153: "", pg154: "", pg155: "", pg156: "", pg157: "", pg158: "", pg159: "", pg160: "",
                    pg161: "", pg162: "", pg163: "", pg164: "", pg165: "", pg166: "", pg167: "", pg168: "", pg169: "", pg170: "",
                    pg171: "", pg172: "", pg173: "", pg174: "", pg175: "", pg176: "", pg177: "", pg178: "", pg179: "", pg180: "",
                    pg181: "", pg182: "", pg183: "", pg184: "", pg185: "", pg186: "", pg187: "", pg188: "", pg189: "", pg190: "",
                    pg191: "", pg192: "", pg193: "", pg194: "", pg195: "", pg196: "", pg197: "", pg198: "", pg199: "", pg200: "",
                    pg201: "", pg202: "", pg203: "", pg204: "", pg205: "", pg206: "", pg207: "", 
               }

               /* Variables para un nuevo caso */
               store.state.eval_solemp = this.eval_solemp;
          },
          /** .................... ACCIONES EN LA BASE DE DATOS  .................... */
          /* Acciones del Floatting Button: Agregar Encuesta */
          agregarEvaluacion() {

               this.finalizoeval = true;
               this.eval_solemp.termino = this.cargaHora();

               /** la pregunta 3 */
               let fecha3 = this.dateToYYYYMMDD(this.eval_solemp.pg003);
               console.log("fecha 3 ? ", fecha3,", tipo ? ",typeof(fecha3));

               let ldia2 = fecha3.substring(9,10);
               let ldia22= parseInt(ldia2);
               if (ldia22 <= 9) {
                    ldia2 = '0' + ldia2;
               } else {
                    ldia2 = ldia2;
               }
               let lmes2 = fecha3.substring(6,7);
               let lmes22 = parseInt(lmes2);
               if (lmes22 <= 9) {
                    lmes2 = '0' + lmes2;
               } else {
                    lmes = lmes2;
               }
               let lanio= fecha3.substring(0,4);
               console.log("dia ? ", ldia2, ", mes ? ", lmes2, ", anio ? ", lanio);
               let latres = ldia2 + '/' + lmes2 + '/' + lanio;
               console.log("latres ? ",latres);

               /** ****************************************** */
               // this.eval_fecha = new Date();

               let ldia = this.eval_fecha.getDate();
               if (ldia <= 9) {
                    ldia = '0' + ldia.toString().trim();
               } else {
                    ldia = ldia.toString().trim();
               }
               let lmes = this.eval_fecha.getMonth() + 1;
               if (lmes <= 9) {
                    lmes = '0' + lmes.toString().trim();
               } else {
                    lmes = lmes.toString().trim();
               }
               console.log("dia ? ", ldia, ", mes ? ", lmes, ", anio ? ", this.eval_fecha.getFullYear());
               let lingreso = ldia + '/' + lmes + '/' + this.eval_fecha.getFullYear();


               console.log("*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-");
               console.log("** fecha de ingreso ? ", this.eval_fecha);
               console.log("** formato  ingreso ? ", lingreso);
               console.log("bd ? ", store.state.st_dbEvalSolemp);
               console.log("solicitud ? ",this.eval_solemp);

               var confirma = confirm("Seguro de grabar la evaluación de SOLICITUD DE EMPLEO para " + this.eval_solemp.nombre.toUpperCase().trim() + " ?");
               if (confirma === true) {

                    /* Agrega una colección al objeto */
                    var dbEvaluaciones = store.state.st_dbEvalSolemp;
                    dbEvaluaciones.push({

                         empresa: this.eval_solemp.empresa, nombre: this.eval_solemp.nombre,
                         empezo: this.eval_solemp.empezo, termino: this.eval_solemp.termino,
                         fecha: lingreso, sexo: this.eval_solemp.sexo,
                         pg001: this.eval_solemp.pg001, pg002: this.eval_solemp.pg002, pg003: latres, pg004: this.eval_solemp.pg004, pg005: this.eval_solemp.pg005,
                         pg006: this.eval_solemp.pg006, pg007: this.eval_solemp.pg007, pg008: this.eval_solemp.pg008, pg009: this.eval_solemp.pg009, pg010: this.eval_solemp.pg010,
                         pg011: this.eval_solemp.pg011, pg012: this.eval_solemp.pg012, pg013: this.eval_solemp.pg013, pg014: this.eval_solemp.pg014, pg015: this.eval_solemp.pg015,
                         pg016: this.eval_solemp.pg016, pg017: this.eval_solemp.pg017, pg018: this.eval_solemp.pg018, pg019: this.eval_solemp.pg019, pg020: this.eval_solemp.pg020,
                         pg021: this.eval_solemp.pg021, pg022: this.eval_solemp.pg022, pg023: this.eval_solemp.pg023, pg024: this.eval_solemp.pg024, pg025: this.eval_solemp.pg025,
                         pg026: this.eval_solemp.pg026, pg027: this.eval_solemp.pg027, pg028: this.eval_solemp.pg028, pg029: this.eval_solemp.pg029, pg030: this.eval_solemp.pg030,
                         pg031: this.eval_solemp.pg031, pg032: this.eval_solemp.pg032, pg033: this.eval_solemp.pg033, pg034: this.eval_solemp.pg034, pg035: this.eval_solemp.pg035,
                         pg036: this.eval_solemp.pg036, pg037: this.eval_solemp.pg037, pg038: this.eval_solemp.pg038, pg039: this.eval_solemp.pg039, pg040: this.eval_solemp.pg040,
                         pg041: this.eval_solemp.pg041, pg042: this.eval_solemp.pg042, pg043: this.eval_solemp.pg043, pg044: this.eval_solemp.pg044, pg045: this.eval_solemp.pg045,
                         pg046: this.eval_solemp.pg046, pg047: this.eval_solemp.pg047, pg048: this.eval_solemp.pg048, pg049: this.eval_solemp.pg049, pg050: this.eval_solemp.pg050,
                         pg051: this.eval_solemp.pg051, pg052: this.eval_solemp.pg052, pg053: this.eval_solemp.pg053, pg054: this.eval_solemp.pg054, pg055: this.eval_solemp.pg055,
                         pg056: this.eval_solemp.pg056, pg057: this.eval_solemp.pg057, pg058: this.eval_solemp.pg058, pg059: this.eval_solemp.pg059, pg060: this.eval_solemp.pg060,
                         pg061: this.eval_solemp.pg061, pg062: this.eval_solemp.pg062, pg063: this.eval_solemp.pg063, pg064: this.eval_solemp.pg064, pg065: this.eval_solemp.pg065,
                         pg066: this.eval_solemp.pg066, pg067: this.eval_solemp.pg067, pg068: this.eval_solemp.pg068, pg069: this.eval_solemp.pg069, pg070: this.eval_solemp.pg070,
                         pg071: this.eval_solemp.pg071, pg072: this.eval_solemp.pg072, pg073: this.eval_solemp.pg073, pg074: this.eval_solemp.pg074, pg075: this.eval_solemp.pg075,
                         pg076: this.eval_solemp.pg076, pg077: this.eval_solemp.pg077, pg078: this.eval_solemp.pg078, pg079: this.eval_solemp.pg079, pg080: this.eval_solemp.pg080,
                         pg081: this.eval_solemp.pg081, pg082: this.eval_solemp.pg082, pg083: this.eval_solemp.pg083, pg084: this.eval_solemp.pg084, pg085: this.eval_solemp.pg085,
                         pg086: this.eval_solemp.pg086, pg087: this.eval_solemp.pg087, pg088: this.eval_solemp.pg088, pg089: this.eval_solemp.pg089, pg090: this.eval_solemp.pg090,
                         pg091: this.eval_solemp.pg091, pg092: this.eval_solemp.pg092, pg093: this.eval_solemp.pg093, pg094: this.eval_solemp.pg094, pg095: this.eval_solemp.pg095,
                         pg096: this.eval_solemp.pg096, pg097: this.eval_solemp.pg097, pg098: this.eval_solemp.pg098, pg099: this.eval_solemp.pg099, pg100: this.eval_solemp.pg100,
                         pg101: this.eval_solemp.pg101, pg102: this.eval_solemp.pg102, pg103: this.eval_solemp.pg103, pg104: this.eval_solemp.pg104, pg105: this.eval_solemp.pg105,
                         pg106: this.eval_solemp.pg106, pg107: this.eval_solemp.pg107, pg108: this.eval_solemp.pg108, pg109: this.eval_solemp.pg109, pg110: this.eval_solemp.pg110,

                         pg111: this.eval_solemp.pg111, pg112: this.eval_solemp.pg112, pg113: this.eval_solemp.pg113, pg114: this.eval_solemp.pg114, pg115: this.eval_solemp.pg115,
                         pg116: this.eval_solemp.pg116, pg117: this.eval_solemp.pg117, pg118: this.eval_solemp.pg118, pg119: this.eval_solemp.pg119, pg120: this.eval_solemp.pg120,
                         pg121: this.eval_solemp.pg121, pg122: this.eval_solemp.pg122, pg123: this.eval_solemp.pg123, pg124: this.eval_solemp.pg124, pg125: this.eval_solemp.pg125,
                         pg126: this.eval_solemp.pg126, pg127: this.eval_solemp.pg127, pg128: this.eval_solemp.pg128, pg129: this.eval_solemp.pg129, pg130: this.eval_solemp.pg130,
                         pg131: this.eval_solemp.pg131, pg132: this.eval_solemp.pg132, pg133: this.eval_solemp.pg133, pg134: this.eval_solemp.pg134, pg135: this.eval_solemp.pg135,
                         pg136: this.eval_solemp.pg136, pg137: this.eval_solemp.pg137, pg138: this.eval_solemp.pg138, pg139: this.eval_solemp.pg139, pg140: this.eval_solemp.pg140,
                         pg141: this.eval_solemp.pg141, pg142: this.eval_solemp.pg142, pg143: this.eval_solemp.pg143, pg144: this.eval_solemp.pg144, pg145: this.eval_solemp.pg145,
                         pg146: this.eval_solemp.pg146, pg147: this.eval_solemp.pg147, pg148: this.eval_solemp.pg148, pg149: this.eval_solemp.pg149, pg150: this.eval_solemp.pg150,
                         pg151: this.eval_solemp.pg151, pg152: this.eval_solemp.pg152, pg153: this.eval_solemp.pg153, pg154: this.eval_solemp.pg154, pg155: this.eval_solemp.pg155,
                         pg156: this.eval_solemp.pg156, pg157: this.eval_solemp.pg157, pg158: this.eval_solemp.pg158, pg159: this.eval_solemp.pg159, pg160: this.eval_solemp.pg160,
                         pg161: this.eval_solemp.pg161, pg162: this.eval_solemp.pg162, pg163: this.eval_solemp.pg163, pg164: this.eval_solemp.pg164, pg165: this.eval_solemp.pg165,
                         pg166: this.eval_solemp.pg166, pg167: this.eval_solemp.pg167, pg168: this.eval_solemp.pg168, pg169: this.eval_solemp.pg169, pg170: this.eval_solemp.pg170,
                         pg171: this.eval_solemp.pg171, pg172: this.eval_solemp.pg172, pg173: this.eval_solemp.pg173, pg174: this.eval_solemp.pg174, pg175: this.eval_solemp.pg175,
                         pg176: this.eval_solemp.pg176, pg177: this.eval_solemp.pg177, pg178: this.eval_solemp.pg178, pg179: this.eval_solemp.pg179, pg180: this.eval_solemp.pg180,
                         pg181: this.eval_solemp.pg181, pg182: this.eval_solemp.pg182, pg183: this.eval_solemp.pg183, pg184: this.eval_solemp.pg184, pg185: this.eval_solemp.pg185,
                         pg186: this.eval_solemp.pg186, pg187: this.eval_solemp.pg187, pg188: this.eval_solemp.pg188, pg189: this.eval_solemp.pg189, pg190: this.eval_solemp.pg190,
                         pg191: this.eval_solemp.pg191, pg192: this.eval_solemp.pg192, pg193: this.eval_solemp.pg193, pg194: this.eval_solemp.pg194, pg195: this.eval_solemp.pg195,
                         pg196: this.eval_solemp.pg196, pg197: this.eval_solemp.pg197, pg198: this.eval_solemp.pg198, pg199: this.eval_solemp.pg199, pg200: this.eval_solemp.pg200,
                         pg201: this.eval_solemp.pg201, pg202: this.eval_solemp.pg202, pg203: this.eval_solemp.pg203, pg204: this.eval_solemp.pg204, pg205: this.eval_solemp.pg205,
                         pg206: this.eval_solemp.pg206, pg207: this.eval_solemp.pg207, 

                    }).then((data) => {

                         /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                         this.limpiarEvaluacion();

                         var laClave = data.key;
                         this.grabado = true;
                         this.inicioeval = false;

                         // console.log("[culturaGforma- agregarEvaluacion], La clave almacenada es ? ",laClave);
                         alert("Evaluación de SOLICITUD DE EMPLEO guardado con éxito.")
                    });
               } // if (confirma)
          }, // agregarEncuesta()


          //? =================================================================================
          enfoqueG1(pestana){

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2:
                         Vue.nextTick().then(()=> this.$refs.testtt2.focus());

                         this.activott1="!active";
                         this.activott2="active";

                         this.vertt1=false;
                         this.vertt2=true;
                         break;
                    case 3:
                         Vue.nextTick().then(()=> this.$refs.testtt3.focus());
                         this.activott2="!active";
                         this.activott3="active";

                         this.vertt2=false;                         
                         this.vertt3=true;
                         break;
                    case 4:
                         Vue.nextTick().then(()=> this.$refs.testtt4.focus());
                         this.activott3="!active";
                         this.activott4="active";

                         this.vertt3=false;                         
                         this.vertt4=true;
                         break;
                    case 5:
                         Vue.nextTick().then(()=> this.$refs.testtt5.focus());
                         this.activott4="!active";
                         this.activott5="active";

                         this.vertt4=false;                         
                         this.vertt5=true;
                         break;
                    case 6:
                         Vue.nextTick().then(()=> this.$refs.testtt6.focus());
                         this.activott5="!active";
                         this.activott6="active";

                         this.vertt5=false;                         
                         this.vertt6=true;
                         break;
                    case 7:
                         Vue.nextTick().then(()=> this.$refs.testtt7.focus());
                         this.activott6="!active";
                         this.activott7="active";

                         this.vertt6=false;                         
                         this.vertt7=true;
                         break;
                    case 8:
                         Vue.nextTick().then(()=> this.$refs.testtt8.focus());
                         this.activott9="!active";
                         this.activott8="active";

                         this.vertt7=false;                         
                         this.vertt8=true;
                         break;
                    case 9:
                         Vue.nextTick().then(()=> this.$refs.testtt9.focus());
                         this.activott8="!active";
                         this.activott9="active";

                         this.vertt8=false;                         
                         this.vertt9=true;
                         break;
  
                    case 0:
                         Vue.nextTick().then(()=> this.$refs.testtt1.focus());
                         this.activott9="!active";
                         this.activott1="active";

                         this.vertt9=false;
                         this.vertt1=true;
                         break;
                    default:                         
                    // code block
               } //* switch
          },
          nadaG1(pestana){
               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:
                         Vue.nextTick().then(()=> this.$refs.testtt1.focus());

                         this.activott1="active";
                         this.activott2="!active";
                         this.activott3="!active";
                         this.activott4="!active";
                         this.activott5="!active";
                         this.activott6="!active";
                         this.activott7="!active";
                         this.activott8="!active";
                         this.activott9="!active";

                         this.vertt1=true;
                         this.vertt2=false;
                         this.vertt3=false;
                         this.vertt4=false;
                         this.vertt5=false;
                         this.vertt6=false;
                         this.vertt7=false;
                         this.vertt8=false;
                         this.vertt9=false;

                         break;
                    case 2:
                         Vue.nextTick().then(()=> this.$refs.testtt2.focus());
                         this.activott1="!active";
                         this.activott2="active";
                         this.activott3="!active";
                         this.activott4="!active";
                         this.activott5="!active";
                         this.activott6="!active";
                         this.activott7="!active";
                         this.activott8="!active";
                         this.activott9="!active";

                         this.vertt1=false;
                         this.vertt2=true;
                         this.vertt3=false;
                         this.vertt4=false;
                         this.vertt5=false;
                         this.vertt6=false;
                         this.vertt7=false;
                         this.vertt8=false;
                         this.vertt9=false;

                         break;
                    case 3:
                         Vue.nextTick().then(()=> this.$refs.testtt3.focus());
                         this.activott1="!active";
                         this.activott2="!active";
                         this.activott3="active";
                         this.activott4="!active";
                         this.activott5="!active";
                         this.activott6="!active";
                         this.activott7="!active";
                         this.activott8="!active";
                         this.activott9="!active";

                         this.vertt1=false;
                         this.vertt2=false;
                         this.vertt3=true;
                         this.vertt4=false;
                         this.vertt5=false;
                         this.vertt6=false;
                         this.vertt7=false;
                         this.vertt8=false;
                         this.vertt9=false;
                         break;
                    case 4:
                         Vue.nextTick().then(()=> this.$refs.testtt4.focus());
                         this.activott1="!active";
                         this.activott2="!active";
                         this.activott3="!active";
                         this.activott4="active";
                         this.activott5="!active";
                         this.activott6="!active";
                         this.activott7="!active";
                         this.activott8="!active";
                         this.activott9="!active";

                         this.vertt1=false;
                         this.vertt2=false;
                         this.vertt3=false;
                         this.vertt4=true;
                         this.vertt5=false;
                         this.vertt6=false;
                         this.vertt7=false;
                         this.vertt8=false;
                         this.vertt9=false;
                         break;
                    case 5:
                         Vue.nextTick().then(()=> this.$refs.testtt5.focus());
                         this.activott1="!active";
                         this.activott2="!active";
                         this.activott3="!active";
                         this.activott4="!active";
                         this.activott5="active";
                         this.activott6="!active";
                         this.activott7="!active";
                         this.activott8="!active";
                         this.activott9="!active";

                         this.vertt1=false;
                         this.vertt2=false;
                         this.vertt3=false;
                         this.vertt4=false;
                         this.vertt5=true;
                         this.vertt6=false;
                         this.vertt7=false;
                         this.vertt8=false;
                         this.vertt9=false;
                         break;
                    case 6:
                         Vue.nextTick().then(()=> this.$refs.testtt6.focus());
                         this.activott1="!active";
                         this.activott2="!active";
                         this.activott3="!active";
                         this.activott4="!active";
                         this.activott5="!active";
                         this.activott6="active";
                         this.activott7="!active";
                         this.activott8="!active";
                         this.activott9="!active";

                         this.vertt1=false;
                         this.vertt2=false;
                         this.vertt3=false;
                         this.vertt4=false;
                         this.vertt5=false;
                         this.vertt6=true;
                         this.vertt7=false;
                         this.vertt8=false;
                         this.vertt9=false;
                         break;
                    case 7:
                         Vue.nextTick().then(()=> this.$refs.testtt7.focus());
                         this.activott1="!active";
                         this.activott2="!active";
                         this.activott3="!active";
                         this.activott4="!active";
                         this.activott5="!active";
                         this.activott6="!active";
                         this.activott7="active";
                         this.activott8="!active";
                         this.activott9="!active";

                         this.vertt1=false;
                         this.vertt2=false;
                         this.vertt3=false;
                         this.vertt4=false;
                         this.vertt5=false;
                         this.vertt6=false;
                         this.vertt7=true;
                         this.vertt8=false;
                         this.vertt9=false;
                         break;
                    case 8:
                         Vue.nextTick().then(()=> this.$refs.testtt8.focus());
                         this.activott1="!active";
                         this.activott2="!active";
                         this.activott3="!active";
                         this.activott4="!active";
                         this.activott5="!active";
                         this.activott6="!active";
                         this.activott7="!active";
                         this.activott8="active";
                         this.activott9="!active";

                         this.vertt1=false;
                         this.vertt2=false;
                         this.vertt3=false;
                         this.vertt4=false;
                         this.vertt5=false;
                         this.vertt6=false;
                         this.vertt7=false;
                         this.vertt8=true;
                         this.vertt9=false;
                         break;
                    case 9:
                         Vue.nextTick().then(()=> this.$refs.testtt9.focus());
                         this.activott1="!active";
                         this.activott2="!active";
                         this.activott3="!active";
                         this.activott4="!active";
                         this.activott5="!active";
                         this.activott6="!active";
                         this.activott7="!active";
                         this.activott8="!active";
                         this.activott9="active";

                         this.vertt1=false;
                         this.vertt2=false;
                         this.vertt3=false;
                         this.vertt4=false;
                         this.vertt5=false;
                         this.vertt6=false;
                         this.vertt7=false;
                         this.vertt8=false;
                         this.vertt9=true;
                         break;

                    default:                         
                    // code block
               } //* switch
          },
          enfoqueRG1(pestana){

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {

                    case 8: //* Estoy en 9 regreso a 8
                         Vue.nextTick().then(()=> this.$refs.testtt8.focus());

                         this.activott9="!active";
                         this.activott8="active";

                         this.vertt9=false;
                         this.vertt8=true;
                         break;
                    case 7: //* Estoy en 8 regreso a 7
                         Vue.nextTick().then(()=> this.$refs.testtt7.focus());

                         this.activott8="!active";
                         this.activott7="active";

                         this.vertt8=false;
                         this.vertt7=true;
                         break;
                    case 6: //* Estoy en 7 regreso a 6
                         Vue.nextTick().then(()=> this.$refs.testtt6.focus());

                         this.activott7="!active";
                         this.activott6="active";

                         this.vertt7=false;
                         this.vertt6=true;
                         break;
                    case 5: //* Estoy en 6 regreso a 5
                         Vue.nextTick().then(()=> this.$refs.testtt5.focus());

                         this.activott6="!active";
                         this.activott5="active";

                         this.vertt6=false;
                         this.vertt5=true;
                         break;

                    case 4: //* Estoy en 5 regreso a 4
                         Vue.nextTick().then(()=> this.$refs.testtt4.focus());

                         this.activott5="!active";
                         this.activott4="active";

                         this.vertt5=false;
                         this.vertt4=true;
                         break;
                    case 3: //* Estoy en 4 regreso a 3
                         Vue.nextTick().then(()=> this.$refs.testtt3.focus());

                         this.activott4="!active";
                         this.activott3="active";

                         this.vertt4=false;
                         this.vertt3=true;
                         break;
                    case 2: //* Estoy en 3 regreso a 2
                         Vue.nextTick().then(()=> this.$refs.testtt2.focus());

                         this.activott3="!active";
                         this.activott2="active";

                         this.vertt3=false;
                         this.vertt2=true;
                         break;
                    case 1:   //* Estoy en 2 regreso a 1
                         Vue.nextTick().then(()=> this.$refs.testtt1.focus());
                         this.activott2="!active";
                         this.activott1="active";

                         this.vertt2=false;                         
                         this.vertt1=true;
                         break;
                    default:                         
                    // code block
               } //* switch
          },
                    
     }, // methods
} // export



// WEBPACK FOOTER //
// ./src/components/ev08_solemp.js